export const MEETINGS_LIST = 'MEETINGS_LIST';
export const CUSTOMER_MEETING_PLANNER = 'CUSTOMER_MEETING_PLANNER';
export const MEETING_PLANNER_MEETINGS = 'MEETING_PLANNER_MEETINGS';
export const MEETING_SPONSORS = 'MEETING_SPONSORS';
export const ACCEPT_INVITATION = 'ACCEPT_INVITATION';
export const REFUSE_INVITATION = 'REFUSE_INVITATION';
export const AVAILABLE_SLOTS_MODAL_ID = 'AVAILABLE_SLOTS_MODAL_ID';
